/* eslint-disable import/prefer-default-export */
export const fieldsByCurrency = {
  USD: [
    'beneficiary',
    'beneficiaryAddress',
    'bankName',
    'bankAddress',
    'transferMethod',
    'accountType',
    'accountNumber',
    'routingCode',
    'swiftCode',
  ],
  MXN: [
    'transferMethod',
    'accountNumber',
    'beneficiary',
    'bankName',
    'bankAddress',
  ],
  EUR: [
    'beneficiary',
    'beneficiaryAddress',
    'bankName',
    'bankAddress',
    'transferMethod',
    'accountNumber',
    'swiftCode',
  ],
  CAD: [
    'beneficiary',
    'beneficiaryAddress',
    'bankName',
    'bankAddress',
    'transferMethod',
    'accountType',
    'accountNumber',
    'routingCode',
    'swiftCode',
  ],
  HKD: [
    'beneficiary',
    'beneficiaryAddress',
    'bankName',
    'bankAddress',
    'transferMethod',
    'accountType',
    'accountNumber',
    'routingCode',
    'swiftCode',
  ],
  GBP: [
    'beneficiary',
    'beneficiaryAddress',
    'bankName',
    'bankAddress',
    'accountNumber',
    'swiftCode',
    'transferMethod',
  ],
};
